import React from "react";
import TitleBox from "../TitleBox";

interface OnboardingLayoutProps {
  title: React.ReactNode;
  subtitle: React.ReactNode;
  children: React.ReactNode;
  classname?: string;
}

const OnboardingLayout: React.FC<OnboardingLayoutProps> = ({
  title,
  subtitle,
  children,
  classname,
}) => {
  return (
    <div className={`flex flex-col w-full h-full justify-start items-center py-2 overflow-x-hidden overflow-y-auto`}>
      <div className="pt-4 px-2 pb-2 w-full">
        <TitleBox
          title={title}
          subtitle={subtitle}
          classname={classname}
        />
      </div>
      <div className="flex flex-col w-full h-full gap-8 flex-grow justify-center items-center">
        {children}
      </div>
    </div>
  );
};

export default OnboardingLayout;